module.exports = __webpack_public_path__ + "img/组4(1).4cd49a3d.png";